import api from '@/services/api';

const UserSettingsQuery = {
  getUserDialogSettings: () => {
    return api.get('get_user_dialog_settings/');
  }
};

export default UserSettingsQuery;



// WEBPACK FOOTER //
// ./src/api/account/user_settings/query.js